<!-- new project list design start -->
 <div class="hire-search-card mb-1">
    <div>
        <input data-testid="auto-app-project-list-input-1" style="width: 300px;" type="text" class="wc-form-control nobg" [formControl]="searchInput"
          placeholder="Search Project Name">
    </div>
    <div class="d-flex">
      <div class="dropdown filter-icon">
            <a data-testid="auto-app-project-list-a-1" class="btn-trms-regular dropdown-toggle filter-btn" role="button" appDropdownToggle
              aria-expanded="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M5.3335 13.3332V6.6665M7.3335 11.3332L5.3335 13.3332L3.3335 11.3332M10.6668 2.6665V9.33317M8.66683 4.6665L10.6668 2.6665L12.6668 4.6665" stroke="#484B59" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>

            <div class="dropdown-menu">
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-2" id="radio-1" class="radio-custom" name="radio-group" type="radio" checked
                  (change)="onFilterChange($event)" value="updatedon_desc" [(ngModel)]="radioBtnFilter">
                <label for="radio-1" class="radio-custom-label">Last Updated On (New to Old)</label>
              </div>
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-3" id="radio-2" class="radio-custom" name="radio-group" type="radio" (change)="onFilterChange($event)"
                  value="updatedon_asc" [(ngModel)]="radioBtnFilter">
                <label for="radio-2" class="radio-custom-label">Last Updated On (Old to new)</label>
              </div>
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-4" id="radio-3" class="radio-custom" name="radio-group" type="radio" (change)="onFilterChange($event)"
                  value="projectname_asc" [(ngModel)]="radioBtnFilter">
                <label for="radio-3" class="radio-custom-label">Project Name (A to Z)</label>
              </div>
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-5" id="radio-4" class="radio-custom" name="radio-group" type="radio" (change)="onFilterChange($event)"
                  value="projectname_desc" [(ngModel)]="radioBtnFilter">
                <label for="radio-4" class="radio-custom-label">Project Name (Z to A)</label>
              </div>
            </div>
      </div>
      <div class="dropdown last-activity">
        <button data-testid="auto-app-project-list-button-1" class="btn-trms-white dropdown-toggle" type="button" id="dropdownMenuButton1" appDropdownToggle
          data-bs-toggle="dropdown" aria-expanded="false">
          Last activity
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M5.83125 7.85625L3.1125 5.1375C3.075 5.1 3.04688 5.05938 3.02813 5.01562C3.00938 4.97188 3 4.925 3 4.875C3 4.775 3.03438 4.6875 3.10313 4.6125C3.17188 4.5375 3.2625 4.5 3.375 4.5H9.075C9.1875 4.5 9.27813 4.5375 9.34688 4.6125C9.41563 4.6875 9.45 4.775 9.45 4.875C9.45 4.9 9.4125 4.9875 9.3375 5.1375L6.61875 7.85625C6.55625 7.91875 6.49375 7.9625 6.43125 7.9875C6.36875 8.0125 6.3 8.025 6.225 8.025C6.15 8.025 6.08125 8.0125 6.01875 7.9875C5.95625 7.9625 5.89375 7.91875 5.83125 7.85625Z" fill="#484B59"/>
          </svg>
          </span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <div class="p-2 optionheader">Last Activity</div>
          <li><a data-testid="auto-app-project-list-a-2" class="dropdown-item" href="#">Name</a></li>
          <li><a data-testid="auto-app-project-list-a-3" class="dropdown-item" href="#">Pipeline Count: High to Low</a></li>
          <li><a data-testid="auto-app-project-list-a-4" class="dropdown-item" href="#">Pipeline Count: Low to High</a></li>
        </ul>
      </div>
    </div>
 </div>
 <div class="project-list-container mb-3">
  <div class="row project-list-header">
    <div class="col header-item">
      Project Name
    </div>
    <div class="col header-item">
      Pipeline Count
    </div>
    <div class="col header-item">
      Recommended Matches
    </div>
    <div class="col header-item">
     Last Updated
    </div>
    <div class="col header-item">
      Status
    </div>
  </div>
  @for(project of tableData; track project.status){
  <div class="row project-list">
    <div class="col list-item">
      <div class="d-flex">
        {{project.name}}

        <!-- <div class="criteria-label autopilot"  *ngIf="project?.migratedfrom == 'autopilot'">
          Autopilot
    </div>
    <div class="criteria-label talentpool"  *ngIf="project?.migratedfrom == 'talentpool'">
          TalentPool
    </div> -->
      </div>
      <div class="owner align-items-center">
        <span class="mr-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2.25 10.5C2.25 10.5 1.5 10.5 1.5 9.75C1.5 9 2.25 6.75 6 6.75C9.75 6.75 10.5 9 10.5 9.75C10.5 10.5 9.75 10.5 9.75 10.5H2.25ZM6 6C6.59674 6 7.16903 5.76295 7.59099 5.34099C8.01295 4.91903 8.25 4.34674 8.25 3.75C8.25 3.15326 8.01295 2.58097 7.59099 2.15901C7.16903 1.73705 6.59674 1.5 6 1.5C5.40326 1.5 4.83097 1.73705 4.40901 2.15901C3.98705 2.58097 3.75 3.15326 3.75 3.75C3.75 4.34674 3.98705 4.91903 4.40901 5.34099C4.83097 5.76295 5.40326 6 6 6Z" fill="#969696"/>
          </svg>
        </span>
        <span>
            {{project.owner}}
        </span>
      </div>
    </div>
     <div class="col list-item">
      {{project.pipelineCount}}
    </div>
     <div class="col list-item">
      <div class="d-flex align-items-baseline">
        <span [ngClass]="project.recommended=='Available' ? 'd-flex mr-2': 'd-none'">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <circle cx="4" cy="4" r="4" fill="#68AA86"/>
          </svg>
        </span>
        <span [ngClass]="project.recommended=='Not Available' ? 'd-flex mr-2': 'd-none'">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
            <circle cx="4" cy="4" r="4" fill="#FBA744"/>
          </svg>
        </span>
        {{project.recommended}}
     </div>
    </div>
     <div class="col list-item">
      {{project.lastUpdate | date: 'mediumDate'}}
    </div>
     <div class="col list-item">
      <div class="d-flex justify-content-between w-100">
        <span>
          {{project.status | titlecase}}
        </span>
        <span class="dropdown ats-dropBtn ml-2">
                <button data-testid="auto-app-project-list-button-2" class="ats-btn btn-break dropdown-toggle ml-3px px-2" type="button" id="userDropdownButton"
                  appDropdownToggle aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="userDropdownButton" >
                  <a data-testid="auto-app-project-list-a-5" class="dropdown-item f-12 isActive" routerLinkActive="active"
                    (click)="!euAccessProjectHandler(project) ? openRenameProjectModel(project) : ''">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2 11.5002V14.0002H4.5L11.8733 6.62683L9.37333 4.12683L2 11.5002ZM13.8067 4.6935C13.8685 4.63182 13.9175 4.55856 13.951 4.47791C13.9844 4.39727 14.0016 4.31081 14.0016 4.2235C14.0016 4.13619 13.9844 4.04973 13.951 3.96908C13.9175 3.88843 13.8685 3.81517 13.8067 3.7535L12.2467 2.1935C12.185 2.1317 12.1117 2.08266 12.0311 2.04921C11.9504 2.01576 11.864 1.99854 11.7767 1.99854C11.6894 1.99854 11.6029 2.01576 11.5223 2.04921C11.4416 2.08266 11.3683 2.1317 11.3067 2.1935L10.0867 3.4135L12.5867 5.9135L13.8067 4.6935Z" fill="#484B59"/>
                      </svg>
                    </span>
                    <span>
                      Rename
                    </span>
                  </a>
                  <a data-testid="auto-app-project-list-a-6" class="dropdown-item f-12 isActive" routerLinkActive="active" (click)="shareProject(project)">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M4.66682 5.83342C4.32164 5.83339 3.98146 5.91584 3.6746 6.07388C3.36774 6.23193 3.10307 6.46101 2.90265 6.74203C2.70223 7.02306 2.57185 7.3479 2.52238 7.68951C2.4729 8.03111 2.50575 8.3796 2.6182 8.70594C2.73065 9.03228 2.91944 9.32703 3.16885 9.56565C3.41826 9.80427 3.72108 9.97984 4.05207 10.0778C4.38306 10.1757 4.73266 10.1931 5.07175 10.1285C5.41083 10.064 5.72959 9.9194 6.00148 9.70675L6.04682 9.74275L9.20015 11.9508C9.10654 12.4726 9.2075 13.0106 9.48394 13.463C9.76037 13.9154 10.1931 14.2508 10.7001 14.4056C11.2072 14.5604 11.7534 14.5239 12.2354 14.303C12.7174 14.0822 13.1016 13.6922 13.3154 13.2071C13.5292 12.722 13.5578 12.1753 13.3956 11.6705C13.2334 11.1658 12.8918 10.738 12.4354 10.4682C11.979 10.1984 11.4395 10.1053 10.9191 10.2065C10.3987 10.3077 9.93347 10.5962 9.61148 11.0174L6.62548 8.92742C6.75882 8.64675 6.83348 8.33208 6.83348 8.00008C6.83348 7.66808 6.75882 7.35342 6.62548 7.07275L9.61215 4.98208C9.93414 5.40327 10.3994 5.69178 10.9198 5.793C11.4402 5.89421 11.9797 5.8011 12.4361 5.5313C12.8924 5.2615 13.2341 4.83373 13.3962 4.32898C13.5584 3.82423 13.5299 3.27753 13.3161 2.79239C13.1023 2.30725 12.718 1.91734 12.2361 1.69648C11.7541 1.47561 11.2079 1.43913 10.7008 1.59393C10.1937 1.74873 9.76103 2.08408 9.4846 2.53647C9.20817 2.98887 9.1072 3.52691 9.20082 4.04875L6.04682 6.25808L6.00148 6.29342C5.62067 5.99492 5.15067 5.83294 4.66682 5.83342Z" fill="#2E93A1"/>
                      </svg>
                    </span>
                    <span>Share</span>
                  </a>
                  <a data-testid="auto-app-project-list-a-7" class="dropdown-item f-12 isActive" routerLinkActive="active" (click)="cloneProject(project)">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 3.25C2 2.98478 2.10536 2.73043 2.29289 2.54289C2.48043 2.35536 2.73478 2.25 3 2.25H10C10.2652 2.25 10.5196 2.35536 10.7071 2.54289C10.8946 2.73043 11 2.98478 11 3.25V4C11 4.13261 10.9473 4.25979 10.8536 4.35355C10.7598 4.44732 10.6326 4.5 10.5 4.5C10.3674 4.5 10.2402 4.44732 10.1464 4.35355C10.0527 4.25979 10 4.13261 10 4V3.25H3V10.25H3.75C3.88261 10.25 4.00979 10.3027 4.10355 10.3964C4.19732 10.4902 4.25 10.6174 4.25 10.75C4.25 10.8826 4.19732 11.0098 4.10355 11.1036C4.00979 11.1973 3.88261 11.25 3.75 11.25H3C2.73478 11.25 2.48043 11.1446 2.29289 10.9571C2.10536 10.7696 2 10.5152 2 10.25V3.25Z" fill="#484B59"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5.25C5.73478 5.25 5.48043 5.35536 5.29289 5.54289C5.10536 5.73043 5 5.98478 5 6.25V13.25C5 13.5152 5.10536 13.7696 5.29289 13.9571C5.48043 14.1446 5.73478 14.25 6 14.25H13C13.2652 14.25 13.5196 14.1446 13.7071 13.9571C13.8946 13.7696 14 13.5152 14 13.25V6.25C14 5.98478 13.8946 5.73043 13.7071 5.54289C13.5196 5.35536 13.2652 5.25 13 5.25H6Z" fill="#484B59"/>
                    </svg>
                  </span>
                  <span class="f-12">
                    Duplicate
                  </span>
                  </a>
                  <a data-testid="auto-app-project-list-a-8" class="dropdown-item f-12 isActive" routerLinkActive="active" (click)="shareProject(project)">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.6668 2.66667H10.3335L9.66683 2H6.3335L5.66683 2.66667H3.3335V4H12.6668M4.00016 12.6667C4.00016 13.0203 4.14064 13.3594 4.39069 13.6095C4.64074 13.8595 4.97987 14 5.3335 14H10.6668C11.0205 14 11.3596 13.8595 11.6096 13.6095C11.8597 13.3594 12.0002 13.0203 12.0002 12.6667V4.66667H4.00016V12.6667Z" fill="#484B59"/>
                      </svg>
                    </span>
                    <span>
                      Delete
                    </span>
                  </a>
                </div>
        </span>
      </div>
    </div>
  </div>
}
 </div>
<!-- new project list design end -->

<div class="wccard px-3 py-2">
  <div class="row">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <!-- Left Side: Title -->
      <div>
        <span class="f-18 font-weight-600" style="color: #484B59;">Projects <span
            *ngIf="autopilotprojectslots && autopilotprojectslots != -1">| <span class="text-9696 font-weight-500"
              *ngIf="autopilotprojectslots && autopilotprojectslots != -1">({{activeProjectCount}}/{{autopilotprojectslots}})
              Active Projects</span></span></span>
      </div>
      <!-- Right Side: Search + Button -->
      <div class="d-flex align-items-center">
        <div class="mr-2">
          <div class="dropdown filter-icon">
            <a data-testid="auto-app-project-list-a-9" class="btn-trms-regular dropdown-toggle filter-btn" role="button" appDropdownToggle
              aria-expanded="false">
              <i class="fa-light fa-arrow-down-arrow-up"></i>
            </a>

            <div class="dropdown-menu">
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-6" id="radio-1" class="radio-custom" name="radio-group" type="radio" checked
                  (change)="onFilterChange($event)" value="updatedon_desc" [(ngModel)]="radioBtnFilter">
                <label for="radio-1" class="radio-custom-label">Last Updated On (New to Old)</label>
              </div>
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-7" id="radio-2" class="radio-custom" name="radio-group" type="radio" (change)="onFilterChange($event)"
                  value="updatedon_asc" [(ngModel)]="radioBtnFilter">
                <label for="radio-2" class="radio-custom-label">Last Updated On (Old to new)</label>
              </div>
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-8" id="radio-3" class="radio-custom" name="radio-group" type="radio" (change)="onFilterChange($event)"
                  value="projectname_asc" [(ngModel)]="radioBtnFilter">
                <label for="radio-3" class="radio-custom-label">Project Name (A to Z)</label>
              </div>
              <div class="position-relative">
                <input data-testid="auto-app-project-list-input-9" id="radio-4" class="radio-custom" name="radio-group" type="radio" (change)="onFilterChange($event)"
                  value="projectname_desc" [(ngModel)]="radioBtnFilter">
                <label for="radio-4" class="radio-custom-label">Project Name (Z to A)</label>
              </div>
            </div>
          </div>
        </div>

        <input data-testid="auto-app-project-list-input-10" style="width: 300px;" type="text" class="wc-form-control nobg" [formControl]="searchInput"
          placeholder="Search Project Name">


        <button data-testid="auto-app-project-list-button-3" type="button" class="btn-trms-medium ml-2" (click)="createproject()">
          Create Project
        </button>


      </div>
    </div>
  </div>
</div>


<!-- For Project List -->
<div class="row mt-1">

  <!-- If Projects List Not Available -->
  <div *ngIf="ProjectList.length === 0 && !showLoaderForProjectList" class="col">
    <div class="w-100 wccard" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Project Created Yet, Start Creating!</p>
      </div>
    </div>
  </div>

  <!-- If Project List Available -->
  <div class="col" *ngIf="ProjectList.length > 0 && !showLoaderForProjectList">
    <!-- Table Header Row -->
    <div class="wccard py-2 px-3" style="margin-bottom: 3px;">
      <div class="row">
        <div class="col-3">
          <span class="f-14 font-weight-400" style="color: #969696;">Project Name</span>
        </div>
        <div class="col">
          <span class="f-14 font-weight-400" style="color: #969696;">Status</span>
        </div>
        <div class="col">
          <span class="f-14 font-weight-400" style="color: #969696;">Summary</span>
        </div>
        <div class="col">
          <span class="f-14 font-weight-400" style="color: #969696;"></span>
        </div>
        <div class="col">
          <span class="f-14 font-weight-400" style="color: #969696;">Owner</span>
        </div>
        <div class="col">
          <span class="f-14 font-weight-400" style="color: #969696;">Updated On</span>
        </div>
        <div class="col  text-right">
          <span class="f-14 font-weight-400" style="color: #969696;">Action</span>
        </div>
      </div>
    </div>

    <!-- Data Rows -->
    <div class="wccard py-2 px-3" style="margin-top: 1px;" *ngFor="let project of ProjectList"
      [ngStyle]="euAccessProjectHandler(project) ? {'background-color': '#FAFAFA'} : {}">
      <div class="row">
        <div class="col-3 text-truncate">
          <p class="f-14 font-weight-500 pointer mb-0 mt-2 text-truncate"
            matTooltip="{{project.projectname}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"
            [ngStyle]="euAccessProjectHandler(project) ? {'color': '#969696'} : {'color': '#2E93A1'}"
            (click)="!euAccessProjectHandler(project) ? projectDetails(project) : ''">
            {{ project.projectname | titlecase }}
          </p>
        </div>

        <div class="col align-items-center d-flex">
          <p class="f-14 font-weight-500 mb-2 mt-2" style="color: #C845AB;"
            *ngIf="project?.aisourcingstatus == 'started'">
            <i class="fa-regular fa-clock mr-1"></i>
            Sourcing
          </p>

          <div *ngIf="project?.aisourcingstatus !== 'started' && isteamAdmin"
            class="chip-dropdown" [ngClass]="project?.status == 'active' ? 'active-chip': 'inactive-chip'">

            <a data-testid="auto-app-project-list-a-10" class="dropdown-toggle chip-toggle" id="statusMenu" appDropdownToggle>
              <div class="d-flex align-items-center">
                <span class="chip-text">{{project?.status | titlecase}}</span>
                <i class="fas fa-angle-down ml-2" ></i>
              </div>
            </a>

            <div class="dropdown-menu" aria-labelledby="statusMenu" >
              <a data-testid="auto-app-project-list-a-11" class="dropdown-item" (click)="changeProjectStatus(project,'active')" *ngIf="project?.status !== 'active'">
                <span class="">Active</span>
              </a>
              <a data-testid="auto-app-project-list-a-12" class="dropdown-item" (click)="changeProjectStatus(project,'inactive')" *ngIf="project?.status !== 'inactive'">
                <span class="">Inactive</span>
              </a>
            </div>
          </div>

        <div *ngIf="project?.aisourcingstatus !== 'started' && !isteamAdmin"
            class="chip-dropdown-disabled" [ngClass]="project?.status == 'active' ? 'active-chip': 'inactive-chip'">

            <span class="" id="statusMenu">
              <div class="d-flex align-items-center">
                <span class="chip-text">{{project?.status | titlecase}}</span>
              </div>
            </span>


          </div>

          <!-- <p class="f-14 font-weight-500 mb-0 mt-2" *ngIf="project?.aisourcingstatus !== 'started'">
            Active</p> -->




        </div>

        <div class="col" *ngIf="project?.aisourcingstatus !== 'started'">
          <span class="f-14 font-weight-500">
            {{ project.unactionedcount }}
          </span>
          <p class="f-12 font-weight-400 text-9696 mb-0 mt-2">To Review</p>
        </div>
        <div class="col" *ngIf="project?.aisourcingstatus == 'started'"></div>

        <div class="col" *ngIf="project?.aisourcingstatus !== 'started'">
          <span class="f-14 font-weight-500">
            {{ project.shortlistedcount }}
          </span>
          <p class="f-12 font-weight-400 text-9696 mb-0 mt-2">Shortlisted</p>
        </div>
        <div class="col" *ngIf="project?.aisourcingstatus == 'started'"></div>

        <div class="col d-flex align-items-center">
          <span class="f-14 font-weight-400">
            {{ project.owner | titlecase }}
          </span>
        </div>

        <div class="col d-flex align-items-center">
          <span class="f-12 font-weight-400 text-9696">
            <i class="fa-regular fa-clock mr-1"></i>
            {{ project.updatedon | date: 'MMM d, y' }}
          </span>
        </div>

        <div class="col d-flex align-items-center justify-content-end">
          <span class="f-14 font-weight-500">
            <span class="text-blue pointer" *ngIf="project?.aisourcingstatus == 'started'"
              (click)="projectDetails(project)">View Insights</span>
            <span class="text-blue pointer" *ngIf="project?.aisourcingstatus == 'completed'"
              (click)="projectDetails(project)">View Project</span>
          </span>

             <span class="dropdown ats-dropBtn ml-2" *ngIf="project?.canrename || project?.canshare">
                <button data-testid="auto-app-project-list-button-4" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
                  appDropdownToggle aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="userDropdownButton" >
                  <a data-testid="auto-app-project-list-a-13" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active"
                    (click)="!euAccessProjectHandler(project) ? openRenameProjectModel(project) : ''" *ngIf="project?.canrename">Rename</a>
                  <a data-testid="auto-app-project-list-a-14" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" *ngIf="project?.canshare" (click)="shareProject(project)">
                   Share Project
                  </a>
                  <a data-testid="auto-app-project-list-a-15" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="cloneProject(project)">
                    Duplicate Project
                  </a>
                </div>
              </span>
        </div>
      </div>
    </div>

    <!-- <div class="d-flex justify-content-center wccard ng-star-inserted email-campaign-pagination" *ngIf="totalCount > 1">
      <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize"
        rotate="false" (pageChange)="onPageChange($event)" [(page)]="currentPage" [ellipses]="false">
        <ng-template ngbPaginationPrevious> Previous </ng-template>
        <ng-template ngbPaginationNext> Next </ng-template>
      </ngb-pagination>
    </div> -->
    <div class="new-card d-flex justify-content-center wccard align-items-center"
      [ngClass]="{'sticky-pagination': isScrolled}" *ngIf="totalCount > 1">
      <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" [pageSize]="profilesPerPage" [rotate]="true"
        (pageChange)="setPage($event)" [(page)]="currentPage">
        <ng-template ngbPaginationPrevious> <span></span></ng-template>
        <ng-template ngbPaginationNext>
          <span>Next</span>
        </ng-template>
      </ngb-pagination>

      <div class="page-selection">
        Showing
        <select data-testid="auto-app-project-list-select-1" class="wc-select" name="" id="" [(ngModel)]="profilesPerPage" (change)="updatePagePreference()">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
        Projects per page
      </div>
    </div>
  </div>


</div>

 <div *ngIf="showLoaderForProjectList">
    <app-project-list-skeleton *ngIf="showLoaderForProjectList"></app-project-list-skeleton>
  </div>


<!-- For Rename Project model -->
<ng-template #renameProjectModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600"></span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <label class="f-14 ">Rename Project</label>
      <input data-testid="auto-app-project-list-input-11" [formControl]="renameProjectInput" placeholder="Enter Project Name" type="text"
        class="wc-form-control nobg">
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectError">Duplicate Tag</span>
      <span class="f-12 text-danger mt-1" *ngIf="renameProjectInputSpecialCharError">Special Character Not
        Allowed</span>
      <span class="f-12 text-danger mt-1" *ngIf="dublicateProjectNameError">Duplicate project name</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-project-list-button-5" class="btn-trms-small mr-3" [ngClass]="{ 'bg-gray': dublicateProjectNameError, 'text-center': showSpinnerLoader }" (click)="renameProject()"
          [disabled]="showSpinnerLoader || renameProjectInputSpecialCharError || renameProjectError || dublicateProjectNameError">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Save'}}
          </span>
        </button>
        <!-- <button data-testid="auto-app-project-list-button-6" class="btn-trms-small" (click)="dismiss()">NO</button> -->
      </div>
    </div>
  </div>
</ng-template>



<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
